import React from "react";
import Generate from "./page/generate/Generate";

const App = () => {
  return (
    <>
      <div className="div_api_keys">
        <a
          href="https://platform.openai.com/api-keys"
          target="_blank"
          className="api_keys"
        >
          Link API KEY
        </a>
      </div>

      <Generate />
    </>
  );
};

export default App;
